import { render, staticRenderFns } from "./TipiBolletta.vue?vue&type=template&id=241b9d60&"
import script from "./TipiBolletta.vue?vue&type=script&lang=ts&"
export * from "./TipiBolletta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports